export default "__VITE_ASSET__DI2yfu8G__"